(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/context.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/context.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createContext,
  useReducer,
  useContext
} = React;
const ValidateContext = createContext();
setGlobal('svs.ticketsValidate.components.ValidateContext', ValidateContext);
const actions = {
  SET_RESULT: 'SET_RESULT'
};
setGlobal('svs.ticketsValidate.components.actions', actions);
const validateReducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case actions.SET_RESULT:
      return _objectSpread(_objectSpread({}, state), {}, {
        result: payload
      });
    default:
      return state;
  }
};
const ValidateProvider = _ref => {
  var _svs$ticketsValidate;
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(validateReducer, {
    result: (_svs$ticketsValidate = svs.ticketsValidate) === null || _svs$ticketsValidate === void 0 || (_svs$ticketsValidate = _svs$ticketsValidate.data) === null || _svs$ticketsValidate === void 0 ? void 0 : _svs$ticketsValidate.validatedTicket
  });
  return React.createElement(ValidateContext.Provider, {
    value: {
      state,
      dispatch
    }
  }, children);
};
setGlobal('svs.ticketsValidate.components.context', {
  ValidateContext,
  ValidateProvider,
  useValidateContext: () => useContext(ValidateContext)
});

 })(window);